import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import FrontHeader from '../views/frontend/Header/Header';
import Footer from '../views/frontend/Footer/Footer';
import { history } from "../redux/store/configureStore";
import {designCenterActions}    from '../redux/actions/designCenterActions';
import isEmpty from "lodash.isempty";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GoogleTagManager from './GoogleTagManager';
import moment from 'moment';
import Cookies from "universal-cookie";
import pusher from "../pusherConfig";

const cookies = new Cookies();

let isLoading = true;
let headTag = 0;

class PublicLayout extends Component {

  constructor(props, context){
    super(props, context);
    this.state = {
      cartStatus:'',
      themeData: '',
      backgroundStyles: {},
      mapKey:'',
      language: '',
      currency: '',
      symbol: '',
      gtm: '',
      fontFamilies: '',
      captchaKey: '',
      custompage:{},
      custompageList:''
    };
    this.handleSearch=this.handleSearch.bind(this);
  }

  componentDidMount(){
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let siteUrl = history.location.pathname.split('/');  
    const { actions: { getThemeData, CustomDataByURL } } = this.props;
    if(!isEmpty(siteUrl) && siteUrl[1] && siteUrl[2] && siteUrl[1] == 'page'){  
      CustomDataByURL({url:siteUrl[2], page:0});
    }
    if(this.props.route.match.path != '/deals-detail/:dealID?'){
      if(siteData && siteData.seo_settings.meta_description){
        document.title = (siteData && siteData.seo_settings.site_title) ? siteData.seo_settings.site_title : 'Payvibe';
        let meta = document.querySelector("meta[name*='description']");
        meta.content = siteData.seo_settings.meta_description;
      }

      if(!document.querySelector("meta[name*='keywords']") && siteData && siteData.seo_settings.meta_keywords){
        const keyword = document.createElement("meta");
        keyword.name="keywords";
        keyword.content = siteData.seo_settings.meta_keywords;
        document.head.appendChild(keyword);
      }

      if(siteData && siteData.seo_settings.analytics_tracking_code_head && headTag === 0){
        headTag = 1;
        document.head.innerHTML += siteData.seo_settings.analytics_tracking_code_head;
      }

      // if(!document.querySelector("noscript[id*='analytic']") && siteData && siteData.seo_settings.analytics_tracking_code_body){
      //   const div = document.createElement("div");
      //   div.id = "analytic";
      //   document.body.appendChild(div);
      //   document.getElementById('analytic').innerHTML = siteData.seo_settings.analytics_tracking_code_body;
      // }

      if(siteData && siteData.seo_settings.tag_manager_tracking_code_body){
        this.setState({gtm: siteData.seo_settings.tag_manager_tracking_code_body});
      }

    } 
    let defaultCity;
    if(siteData){
    
      if(siteData.default_city){
        console.log(cookies.get('akash'));
        //defaultCity = siteData.default_city;
        defaultCity = (cookies.get('akash') ? 
          cookies.get('akash') : ((siteData)?siteData.default_city:""));

        this.setState({mapKey:(!isEmpty(siteData.api_settings) && siteData.api_settings[0].google_map_key != '') ? siteData.api_settings[0].google_map_key : '' })
      }
      this.setState({ fontFamilies: siteData.font_families, captchaKey: !isEmpty(siteData.captchaKey) ? siteData.captchaKey : ''});
    }

    if(siteData){
      if(siteData.currency){
        let symbol = '$'; //(siteData.currency == 'USD') ? '$' : 'C$'; //Changed on client dimand by Visham
        localStorage.setItem("symbol", symbol);
        this.setState({currency: siteData.currency, symbol: '$'})  //(siteData.currency == 'USD') ? '$' : 'C$' in place of '$'
      }
    }


    if(this.state.themeData == '' && !isEmpty(this.props.themeData)){
      this.setState({themeData: this.props.themeData.data});
      if(this.props.themeData.data.background.background_image){
        this.setState({
            backgroundStyles: {
              'backgroundColor': this.props.themeData.data.background.background_color,
              'backgroundImage': `url(${this.props.themeData.data.background.background_image})`,
              'backgroundPosition': 'center',
              'backgroundRepeat': (this.props.themeData.data.background.background_color) ? 'no-repeat' : 'repeat',
              'paddingBottom': '10px'
            }
        });
      }else{
        this.setState({
            backgroundStyles: {
              'backgroundColor': this.props.themeData.data.background.background_color,
              'paddingBottom': '10px'
            }
        });
      }
      
    }
    if(isEmpty(this.props.themeData) && siteData){
      getThemeData({scheduledDate:moment().format("YYYY-MM-DD HH:mm:ss"), cityID: (defaultCity) ? defaultCity : ''});
    }
  }

  componentWillReceiveProps(nextProps){ 
    if(nextProps.themeData && nextProps.themeData.data!=this.state.themeData){
      this.setState({
        themeData: nextProps.themeData.data
      });
      if(nextProps.themeData.data && nextProps.themeData.data.background){
        let bgColor = nextProps.themeData.data.background.background_color;
        let bgImage = nextProps.themeData.data.background.background_image;
        let bgRepeat = (bgColor) ? 'no-repeat' : 'repeat';
        if(bgImage){
          this.setState({
            backgroundStyles: {
              'backgroundColor': bgColor,
              'backgroundImage': `url(${bgImage})`,
              'backgroundPosition': 'center',
              'backgroundRepeat': bgRepeat,
              'paddingBottom': '10px'
            }
          });
        }else{
          this.setState({
            backgroundStyles: {
              'backgroundColor': bgColor,
              'paddingBottom': '10px'
            }
          });
        }
      }
    }

    if(nextProps.custompageList && nextProps.custompageList!=this.state.custompageList) {
      if(nextProps.custompageList.data) {
        this.setState({custompage:nextProps.custompageList.data[0], custompageList:nextProps.custompageList});
      }
    }
  }

  onSearch  = (val) => {
    this.handleSearch(val);
  };

  handleSearch(val){
    const postData = {
      page:this.state.currentPage,
      latitude:(this.props.coords) ? this.props.coords.latitude : '26.846695',
      longitude:(this.props.coords) ? this.props.coords.longitude : '80.946167',
      search:val,
      limit:this.state.linit,
    }

    if(val.length !== 0){
      this.handlePageChange(postData);
    }
  }

  handlePageChange = page => {
    isLoading=true;
    this.setState({
      currentPage: page
    });

    const postData = {
      page:page,
      latitude:'26.846695',
      longitude:'80.946167',
      limit: this.state.limit 
    }

    let permalink = (this.props.route.match && this.props.route.match.params.permalink) ? this.props.route.match.params.permalink : '';
    if (permalink !== '')
    {
      this.setState({permalink: this.props.route.match.params.permalink })
      this.props.categoryWiseDeal(permalink)
    }

  };

  updateSiteProperties(cityID){
    if(cityID) {
      const { actions: { getThemeData } } = this.props;
      getThemeData({scheduledDate:moment().format("YYYY-MM-DD HH:mm:ss"), cityID: cityID});
    }
  }

  setLanguage(language){
    this.setState({language: language});
  }
  render() {
    const Component = this.props.component;
    const route = this.props.route;
    const user  = this.props.user; 
    return (
        <div style={{fontFamily: this.state.fontFamilies ? this.state.fontFamilies : ''}}> 
        {(this.state.gtm) &&
        <GoogleTagManager gtmId={this.state.gtm}  />
        }
        {this.state.themeData &&
          <React.Fragment>
            <FrontHeader route={route} cartStatus={this.state.cartStatus} themeData={this.state.themeData} updateSiteProperties={this.updateSiteProperties.bind(this)}  setLanguage={this.setLanguage.bind(this)} isheader={(isEmpty(this.state.custompage) || (this.state.custompage.header==1))} ismenu={(isEmpty(this.state.custompage) || (this.state.custompage.menu==1))}/>  
            <div style={this.state.backgroundStyles}>
              <Component route={route} themeData={this.state.themeData} mapkey={this.state.mapKey} captchaKey={this.state.captchaKey} language={this.state.language} currency={this.state.currency} symbol={this.state.symbol} customdata={this.state.custompage}  pusher={pusher}/>
            </div>
            {(isEmpty(this.state.custompage) || (this.state.custompage.footer==1)) &&
              <Footer themeData={this.state.themeData} language={this.state.language} />
            }       
          </React.Fragment>
        }
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    error:  state.designCenterReducer.error,
    themeData:  state.designCenterReducer.themeData,
    custompageList: state.designCenterReducer.custompageList,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        ...designCenterActions,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicLayout);



// WEBPACK FOOTER //
// ./src/app/layout/PublicLayout.js